import React, { ReactElement } from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';

interface IRefreshListProps {
  refreshTitles: (showBackdrop?: boolean) => Promise<void>;
}

export const RefreshList = ({ refreshTitles }: IRefreshListProps): ReactElement => (
  <Tooltip color="primary" title="Refresh titles">
    <IconButton aria-label="refresh" onClick={() => refreshTitles()}>
      <Refresh />
    </IconButton>
  </Tooltip>
);
